import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

register("articles-gallery", {
  initCarousel(el) {
    if (!el) return;
    const swiper = new Swiper(el, {
      observer: true,
      observeParents: true,
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 15,
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
    });
  },
  onLoad: function (e) {
    const swiperItems = this.container.querySelectorAll('.articles-gallery__item');
    if (window.innerWidth < 992 || swiperItems.length > 3){
      this.initCarousel(this.container.querySelector(".articles-gallery__list"));
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth < 992){
        this.initCarousel(this.container.querySelector(".articles-gallery__list"));
      }
    });
  },
});
